<template>
  <div class="faq-container">
    <div class="area">
      <div class="row">
        <section
          class="recall col-4 col-md-12"
          v-animated-show="utils.handleScroll"
        >
          <div
            class="content"
            v-if="data.description && data.description.title"
          >
            <Description
              class="title-description default icon-top"
              ref="bannerDescription"
              :title="data.description.title"
              :desc="data.description.desc"
            />
            <p class="more" v-html="data.more"></p>
            <ButtonComponent
              v-if="data.button"
              class="button-description"
              url="/contacts"
              >{{ data.button }}</ButtonComponent
            >
          </div>
        </section>
        <div class="spacer col-2 md-hidden"></div>
        <ExpandableList
          :list="data.list"
          class="col-6 col-md-12 gap-offset"
          v-animated-show="utils.handleScroll"
        />
        <div class="float-art-left"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ExpandableList from "../components/ExpandableList.vue";
import utils from "../utils";
export default {
  name: "Faq",
  props: {
    theme: {
      default: "default",
    },
    data: Object,
  },
  data() {
    return { utils: utils };
  },
  components: {
    ExpandableList,
  },
};
</script>

<style lang="scss">
.faq-container {
  @extend %page-block;
  @media all and (max-width: $md) {
    padding-top: 100px;
  }
  .title-description {
    &.description.default {
      .title {
        @extend %text-h1;
        font-weight: bold;
      }
    }
  }
  .row {
    grid-row-gap: 28px;
    position: relative;
    .button-description {
      width: 214px;
      margin-top: 28px;
    }
  }
  p.more {
    @media all and (max-width: $md) {
      line-height: 1.58em;
    }
    @extend %text-default;
    line-height: 1.6em;
  }
  .phone-link {
    color: $text-main;
    font-weight: bold;
  }
  .description-content {
    @media all and (max-width: $md) {
      margin-right: 100px;
    }
    .title {
      @media all and (max-width: $md) {
        font-size: 24px;
      }
    }
    .desc {
      color: #000000cc;
    }
    @media all and (max-width: $md) {
      grid-gap: 15px;
    }
    grid-gap: 35px;
  }
  .float-art-left,
  .float-art-left-md {
    @media all and (max-width: $md) {
      left: unset;
      right: -70px;
      top: -155px;
      bottom: unset;
      transform: rotate(0deg) scaleX(-1);
      width: 206px;
      height: 288px;
    }
    max-width: 600px;
    max-height: 600px;
    position: absolute;
    background: url(../assets/photos/partners/rozh2_1@2x.png) no-repeat right
      center;
    left: calc((1088px - 100vw) / 2 - 100px);
    width: calc((100vw - 1088px) / 3 + 240px);
    height: calc((100vw - 1088px) / 3 + 240px);
    background-size: contain;
    top: 320px;
  }
}
</style>
